'use client';

import React__default, { useState, useMemo, useImperativeHandle } from 'react';
import { ELanguage } from '../Utils/constants.js';
import translations from './translations.js';
import { ReplaceCVPopupWrapper, Container, CVFileNameContainer, CVFileName, SearchableTag, WarningCard, Footer } from './styles.css.js';
import { createTranslator, isMobile } from '../Utils/helpers.js';
import { Paragraph, Span, Anchor } from '../Typography/components/Variant.js';
import { colors } from '../Colors/index.js';
import SingleRadio from '../SingleRadio/index.js';
import { fileName, formatDateTime } from '../ApplyJobsForm/helper.js';
import WarnIcon from '../icons/WarnIcon.js';
import BottomSheet from '../BottomSheet/index.js';
import Button from '../Button/index.js';

var PopupCVReplace = function (props, ref) {
    var _a = props.maxNumberOfCV, maxNumberOfCV = _a === void 0 ? 3 : _a, _b = props.langCode, langCode = _b === void 0 ? ELanguage.VI : _b, formControl = props.formControl, cvList = props.cvList;
    var t = createTranslator({ translations: translations, currentLanguage: langCode });
    var _c = useState(0), replaceById = _c[0], setReplaceById = _c[1];
    var _d = useState(false), isOpen = _d[0], setIsOpen = _d[1];
    var _e = useState(false), hasError = _e[0], setHasError = _e[1];
    var _f = useState(null), popupResolve = _f[0], setPopupResolve = _f[1];
    var memorizedAttachedCVList = useMemo(function () {
        var maxLength = function (isSearchable) {
            if (!isMobile()) {
                return isSearchable ? 21 : 48;
            }
            return isSearchable ? 10 : 25;
        };
        return cvList
            .filter(function (item) { return item.isAttach === 1; })
            .map(function (item) {
            var _a, _b;
            return {
                id: item.id,
                name: fileName((_a = item.fileName) !== null && _a !== void 0 ? _a : '', maxLength(item.isSearchable)),
                isSearchable: item.isSearchable,
                updatedOn: formatDateTime((_b = item.updatedDate) !== null && _b !== void 0 ? _b : 0, 'DDMMYYYY')
            };
        });
    }, [cvList]);
    var open = function () {
        setIsOpen(true);
        return new Promise(function (resolve) {
            setPopupResolve(function () { return resolve; });
        });
    };
    var handleCancel = function (closeBy) { return function () {
        setIsOpen(false);
        setHasError(false);
        popupResolve === null || popupResolve === void 0 ? void 0 : popupResolve({ closeBy: closeBy, data: { formControl: formControl } });
        setPopupResolve(null);
    }; };
    var handleConfirm = function () {
        if (!replaceById) {
            setHasError(true);
            return;
        }
        setIsOpen(false);
        popupResolve === null || popupResolve === void 0 ? void 0 : popupResolve({ data: { resumeId: replaceById, formControl: formControl }, closeBy: 'accept' });
        setPopupResolve(null);
        setHasError(false);
    };
    useImperativeHandle(ref, function () {
        return {
            open: open,
            isOpen: isOpen
        };
    }, [isOpen]);
    return (React__default.createElement(React__default.Fragment, null, !isMobile() ? (React__default.createElement(ReplaceCVPopupWrapper, { isShow: isOpen, lang: langCode, onClose: handleCancel('closeBtn'), onClickOutside: handleCancel('backdrop'), onClickPrimary: handleConfirm, styleOption: {
            size: 'sm'
        }, option: { isShowClose: false }, text: {
            header: t('You get maximum _s attached CVs', { _s: maxNumberOfCV }),
            primaryBtn: t('Replace'),
            secondaryBtn: t('Cancel')
        } },
        React__default.createElement(Container, null,
            React__default.createElement(Paragraph, { name: 'body', size: 'medium', style: { textAlign: 'center', marginBottom: 16 } }, t('You have got the maximum of _s attached CV on VietnamWorks. ', { _s: maxNumberOfCV })),
            React__default.createElement(Paragraph, { name: 'title', size: 'medium', style: { textAlign: 'center', marginBottom: 8 } }, t('Choose one of existed CV to replace:', { _s: maxNumberOfCV })),
            memorizedAttachedCVList.map(function (cv, index) { return (React__default.createElement(React__default.Fragment, { key: "".concat(cv.id, "-").concat(index) },
                React__default.createElement(SingleRadio, { id: cv.id.toString(), name: 'cv-file', isLeftRadio: true, label: cv.isSearchable
                        ? function () { return (React__default.createElement(CVFileNameContainer, null,
                            React__default.createElement(CVFileName, null, cv.name),
                            React__default.createElement(SearchableTag, null,
                                React__default.createElement(Span, { color: colors.green[50], name: 'label', size: 'small' }, t('Searchable'))))); }
                        : function () { return React__default.createElement(CVFileName, null, cv.name); }, onChange: function (value) {
                        setReplaceById(+value);
                        setHasError(false);
                    } }),
                cv.isSearchable ? (React__default.createElement(WarningCard, null,
                    React__default.createElement(WarnIcon, { size: 16 }),
                    React__default.createElement("div", null,
                        React__default.createElement(Paragraph, { name: 'body', size: 'small' }, t('The replaced attached CV will automatically marks as "Searchable".')),
                        React__default.createElement(Paragraph, null,
                            React__default.createElement(Span, { name: 'body', size: 'small' }, t('You can')),
                            ' ',
                            React__default.createElement(Anchor, { name: 'body', size: 'small', href: "/".concat(t('my-profile'), "?tab=profile-settings"), color: colors.primary[40] }, t('switch the searchable CVs in Profile settings')))))) : null)); }),
            React__default.createElement(Paragraph, { style: { margin: '8px 0', textAlign: 'left' }, size: 'medium' },
                t('Note: The CV replacement'),
                ' ',
                React__default.createElement("strong", null, t('will not change the CV sent to employers.'))),
            hasError ? (React__default.createElement(Paragraph, { name: 'body', size: 'medium', style: { textAlign: 'right' }, color: colors.error[40] }, t('Please select a CV to replace'))) : null))) : (React__default.createElement(BottomSheet, { isOpen: isOpen, onClose: handleCancel('closeBtn'), options: { isHaveCloseIcon: false }, header: t('You get maximum _s attached CVs', { _s: maxNumberOfCV }), footer: React__default.createElement(Footer, null,
            React__default.createElement(Button, { onClick: handleCancel('closeBtn'), style: { width: '50%' } }, t('Cancel')),
            React__default.createElement(Button, { type: 'primary', onClick: function () { return handleConfirm(); }, style: { width: '50%' } }, t('Replace'))), styleOption: {
            zIndex: 1100
        } },
        React__default.createElement(Container, null,
            React__default.createElement(Paragraph, { name: 'body', size: 'medium', style: { marginBottom: 16 } }, t('You have got the maximum of _s attached CV on VietnamWorks. ', { _s: maxNumberOfCV })),
            React__default.createElement(Paragraph, { name: 'title', size: 'medium', style: { marginBottom: 8 } }, t('Choose one of existed CV to replace:', { _s: maxNumberOfCV })),
            memorizedAttachedCVList.map(function (cv, index) { return (React__default.createElement(React__default.Fragment, { key: "".concat(cv.id, "-").concat(index) },
                React__default.createElement(SingleRadio, { id: cv.id.toString(), name: 'cv-file', isLeftRadio: true, label: cv.isSearchable
                        ? function () { return (React__default.createElement(CVFileNameContainer, null,
                            React__default.createElement(CVFileName, null,
                                cv.name,
                                " - ",
                                cv.updatedOn),
                            React__default.createElement(SearchableTag, { isMobile: isMobile() },
                                React__default.createElement(Span, { color: colors.green[50], name: 'label', size: 'small' }, t('Searchable'))))); }
                        : cv.name, onChange: function (value) {
                        setReplaceById(+value);
                        setHasError(false);
                    } }),
                cv.isSearchable ? (React__default.createElement(WarningCard, null,
                    React__default.createElement(WarnIcon, { size: 16 }),
                    React__default.createElement("div", null,
                        React__default.createElement(Paragraph, { name: 'body', size: 'small' }, t('The replaced attached CV will automatically marks as "Searchable".')),
                        React__default.createElement(Paragraph, null,
                            React__default.createElement(Span, { name: 'body', size: 'small' }, t('You can')),
                            ' ',
                            React__default.createElement(Anchor, { name: 'body', size: 'small', href: "/".concat(t('my-profile'), "?tab=profile-settings"), color: colors.primary[40] }, t('switch the searchable CVs in Profile settings')))))) : null)); }),
            React__default.createElement(Paragraph, { style: { margin: '8px 0', textAlign: 'left' }, size: 'medium' },
                t('Note: The CV replacement'),
                ' ',
                React__default.createElement("strong", null, t('will not change the CV sent to employers.'))),
            hasError ? (React__default.createElement(Paragraph, { name: 'body', size: 'medium', style: { textAlign: 'right' }, color: colors.error[40] }, t('Please select a CV to replace'))) : null)))));
};
var PopupCVReplace$1 = React__default.forwardRef(PopupCVReplace);

export { PopupCVReplace$1 as default };
//# sourceMappingURL=index.js.map
